import * as Yup from "yup";

export const MAX_MIN_DATES = {
  MIN: {
    value: "2005-01-01",
    label: "01/01/2005",
  },
  MAX: {
    value: "2040-12-31",
    label: "31/12/2040",
  },
};

export const launchAdjustmentFormSchema = Yup.object({
  type: Yup.string()
    .required("Tipo de ajuste é obrigatório")
    .notOneOf(["0"], "Selecione um tipo de ajuste"),
  billingDate: Yup.string()
    .required("Data do faturamento é obrigatória")
    .test("min-date", `A data mínima é ${MAX_MIN_DATES.MIN.label}`, (value) => {
      if (!value) return true;
      return value >= MAX_MIN_DATES.MIN.value;
    })
    .test("max-date", `A data máxima é ${MAX_MIN_DATES.MAX.label}`, (value) => {
      if (!value) return true;
      return value <= MAX_MIN_DATES.MAX.value;
    }),
  value: Yup.string().required("Valor é obrigatório"),
  activeInvoice: Yup.boolean(),
  description: Yup.string()
    .required("Descrição é obrigatória")
    .max(255, "A descrição deve conter no máximo 255 caracteres"),
});

export type LaunchAdjustmentFormSchema = Yup.InferType<
  typeof launchAdjustmentFormSchema
>;
